import React, { useState, useEffect } from "react";
import {
  DateInput,
  TextInput,
  SelectInput,
  FileInput,
  RadioInput,
  NumberInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import documentsSchema from "../../validation/documentsSchema";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { authActions, inmateAction, publicUserActions } from "../../_store";
import Error from "../error/error";
import CustomLoader from "./../../components/common/ui/Loader";
import Table from "../../components/common/table/Table";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import InmateIcon from "../../assets/green.png";
import AutoIcon from "../../assets/orange.png";
import { history } from "../../_helpers";
import {
  getPastDate,
  getCurrentDate,
  fDate,
  formatDateTimeAMPM,
  MinDate,
  Today,
} from "../../utils/formatTime.js";
import generateXlsx from "../../components/common/export/generateXlsx.js";
import Openemail from "../../assets/open-email.png";
import email from "../../assets/email.png";
import QuarantineRejected from "../../assets/Quarantine rejected.svg";
import QuarantinePending from "../../assets/svg/pending-user.svg";
import ReadDelete from "../../assets/svg/read-and-delete.svg";

import UnReadMsgDelete from "../../assets/svg/unread-message-delete.svg";

import MessageQuaratine from "../../assets/svg/Quarantine_msg.svg";

import ReadMessage from "../../assets/svg/Read-Message.svg";

import UnReadmail from "../../assets/svg/unread-icon-new.svg";

import RejectQuarantine from "../../assets/svg/Quarantine_rejected_msg.svg";

import CODPending from "../../assets/svg/cod_pending.svg";
import { findGraphemeClusters } from "../../components/common/ui/findGraphemeClusters.js";
import useManagementUserAccessPermission from "../../hooks/useManagementUserAccessPermission";


function PublicUserMessage() {
  const { MessageAccessPermission, InmateAccessPermission, PuAccessPermission } = useManagementUserAccessPermission();
  const [showSearchFields, setShowSearchFields] = useState(false);

  const columns = [
    {
      name: "Subject",
      selector: (row) => row?.MessageSubject,
      key: "MessageSubject",
      cell: (row) => (
        <div className="d-flex flex-wrap gap-2 align-items-start">
          <div
            className={` ${MessageAccessPermission[0]?.SubMenuActiveStatus !== 0
              ? "Common_Link_Style"
              : ""
              }`}
            onClick={() => handleNavigateMessageSubject(row?.MessageID)}
          >
            {/* {row?.MessageSubject} */}
            {findGraphemeClusters(row.MessageSubject, false)?.length > 15
              ? findGraphemeClusters(row.MessageSubject, true)
              : row.MessageSubject}
          </div>
          {row?.PhotoReadStatus === "Waiting" && (
            <span className="animate-beat fs-6 text-nowrap text-red fw-bold">
              New
            </span>
          )}
        </div>
      ),
      sortable: true,
    },
    {
      width: '120px',
      name: "From",
      selector: (row) => row.MessageFrom,
      key: "MessageFrom",
      cell: (row) => (
        <div className="d-flex  gap-2 align-items-center">
          <div
            className={
              row?.Sender === "PublicUser"
                ? "user-batch button-success"
                : "user-batch button-primary"
            }
          ></div>
          <div
            className={` ${row?.Sender === "PublicUser" ? PuAccessPermission[0]?.SubMenuActiveStatus !== 0 ? "Common_Link_Style" : "" :
              InmateAccessPermission[0]?.SubMenuActiveStatus !== 0 ? "Common_Link_Style" : ""
              }`}
            onClick={() => {
              if (row?.Sender === "PublicUser") {
                handleNavigateInfoFrom(row);
                return;
              } else {
                handleNavigateInmateTo(row);
              }
            }}
          >
            {row.MessageFrom}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      width: '120px',
      name: "To",
      selector: (row) => row?.MessageTo,
      key: "MessageTo",
      sortable: true,
      cell: (row) => (
        <div className="d-flex  gap-2 align-items-center">
          <div
            className={
              row?.Receiver === "PublicUser"
                ? "user-batch button-success"
                : "user-batch button-primary"
            }
          ></div>

          <div
            className={` ${row?.Receiver === "Inmate" ? InmateAccessPermission[0]?.SubMenuActiveStatus !== 0 ? "Common_Link_Style" : "" :
              PuAccessPermission[0]?.SubMenuActiveStatus !== 0 ? "Common_Link_Style" : ""
              }`}
            onClick={() => {
              if (row?.Receiver === "Inmate") {
                handleNavigateInmateTo(row);
                return;
              } else {
                handleNavigateInfoFrom(row);
              }
            }}
          >
            {row.MessageTo}
          </div>
        </div>
      ),
    },

    {
      name: "Inmate ID",
      key: "InmateResidentId",
      selector: (row) => row?.InmateResidentId,
      sortable: true,
      cell: (row) => (
        <div
          className={` ${InmateAccessPermission[0]?.SubMenuActiveStatus !== 0 ? "Common_Link_Style" : ""}`}
          onClick={() => handleNavigateInmateId(row)}
        >
          {row?.InmateResidentId}
        </div>
      ),
    },
    {
      name: "Message Cost ($)",
      key: "MessageCost",
      selector: (row) => row?.MessageCost?.toFixed(2), // Format to 2 decimal places
      sortable: true,
    },
    {
      name: "Mode of Payment",
      selector: (row) => row.ModeOfPayment,
      key: "ModeOfPayment",
      cell: (row) => <div title={row.ModeOfPayment}>{row.ModeOfPayment}</div>,
      sortable: true,
    },
    {
      name: "Flag",
      selector: (row) => row.MessageFlag,
      key: "MessageFlag",
      sortable: true,
      cell: (row) =>
        row?.MessageFlag === 2 || row?.MessageFlag === 1 ? (
          <i
            className="fa fa-flag flagged-message fs-2"
            aria-hidden="true"
            title={
              row?.MessageBothFlagKeyWords?.trim()?.length > 0
                ? row?.MessageBothFlagKeyWords
                : ""
            }
          ></i>
        ) : (
          <i
            className="fa fa-flag non-flagged-message fs-2"
            aria-hidden="true"
            title={
              row?.MessageBothFlagKeyWords?.trim()?.length > 0
                ? row?.MessageBothFlagKeyWords
                : ""
            }
          ></i>
        ),
    },
    {
      name: "Sent",
      selector: (row) => row.MessageSentDate,
      key: "MessageSentDate",
      cell: (row) => (
        <div title={formatDate(row.MessageSentDate)}>
          {formatDate(row.MessageSentDate)}
        </div>
      ),
      sortable: true,
    },

    {
      name: "Read",
      selector: (row) => row.MessageReceiveDate,
      key: "MessageReceiveDate",
      cell: (row) => (
        <div title={formatDate(row.MessageReceiveDate)}>
          {/* {row.MessageReceiveDate === null
            ? ""
            : formatDate(row.MessageReceiveDate)} */}
          {(row?.MessageReceiveDate == "0001-01-01T00:00:00" || row?.ModeOfPayment == "COD") ? "-" : formatDateTimeAMPM(row.MessageReceiveDate)}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      key: "MessageStatus",
      sortable: true,
      cell: (row) =>
        row?.MessageStatus === "Read" && row?.IsReceiverMsgDelete === 1 ? (
          <div title="Read & Message Deleted">
            <img alt="status" src={ReadDelete} className="msg-icon" />
          </div>
        ) : row?.MessageStatus === "Unread" &&
          row?.IsReceiverMsgDelete === 1 ? (
          <div title="Unread & Message Deleted">
            <img alt="status" src={UnReadMsgDelete} className="msg-icon" />
          </div>
        ) : row?.MessageStatus === "Read" ? (
          <div title="Read">
            <img alt="status" src={ReadMessage} className="msg-icon" />
          </div>
        ) : row?.MessageStatus === "Unread" ? (
          <div title="Unread">
            <img
              alt="status"
              src={UnReadmail}
              style={{ height: "30px", width: "30px" }}
              title="Unread"
            />
          </div>
        ) : row?.MessageStatus === "Pending Quarantine Approval" ? (
          <div title="Quarantine Message">
            <img alt="status" src={MessageQuaratine} className="msg-icon" />
          </div>
        ) : row?.MessageStatus === "Reject Quarantine" ? (
          <div title="Quarantine Rejected">
            <img alt="status" src={RejectQuarantine} className="msg-icon" />
          </div>
        ) : (
          <div title="C.O.D Pending">
            <img alt="status" src={CODPending} className="msg-icon" />
          </div>
        ),
      // sortable: true,
      center: true,
    },
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert to 12-hour format

    return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
  };

  const location = useLocation();
  const dispatch = useDispatch();
  const { row } = location.state || {};
  const { user } = useSelector((x) => x.auth);
  const {
    loadMessageList,
    loadMessageExcelList,
    inmateFirstName,
    inmateLastName,
    PublicUserCurrentTab,
    infoInformationList,
    publicUserMessageValue,
    loading,
    puInitialMessageSearch: messageList
  } = useSelector((x) => x?.publicUser);
  const [isloading, setIsLoading] = useState(false);
  const rows = useSelector((x) => x?.publicUser?.PublicUserrow);
  const commonFacilityCode = useSelector(
    (state) => state.auth.commonFacilityCode
  );


  useEffect(() => {
    const search = {
      ...messageList,
      FacilityID: commonFacilityCode,
      userID: row?.PublicUserID || rows?.PublicUserID,
      userFirstName: rows?.FirstName || row?.FirstName,
      userLastName: rows?.LastName || row?.LastName,
    };

    dispatch(publicUserActions?.setpuInitialMessageSearch(search));
  }, [commonFacilityCode, row?.PublicUserID, rows?.PublicUserID, row?.FirstName, rows?.FirstName, row?.LastName, rows?.LastName,]);

  useEffect(() => {
    dispatch(publicUserActions?.setPublicUserListRow(row || rows));
  }, []);

  useEffect(() => {
    if (row?.PublicUserID || rows?.PublicUserID) {
      if (messageList?.inmateLastNameId === 0 || messageList?.inmateLastNameId === undefined) {
        dispatch(
          publicUserActions.GetInmateFirstName({
            facilityID: commonFacilityCode,
            lastName: "",
            PublicUserID: row?.PublicUserID || rows?.PublicUserID,
          })
        );
      }
      dispatch(
        publicUserActions.GetInmateLastName({
          facilityID: commonFacilityCode,
          firstName: "",
          PublicUserID: row?.PublicUserID || rows?.PublicUserID,
        })
      );
      setIsLoading(true);
      const search = {
        ...messageList,
        FacilityID: commonFacilityCode,
        userID: row?.PublicUserID || rows?.PublicUserID,
        userFirstName: rows?.FirstName || row?.FirstName,
        userLastName: rows?.LastName || row?.LastName,
      };
      dispatch(publicUserActions.LoadPUMessageSearch(search)).then((x) => setIsLoading(false));
    }
  }, [row]);


  useEffect(() => {
    if (loadMessageExcelList && loadMessageExcelList?.DataList?.length > 0) {
      const title = "Message_List";
      let generateExcelColumns = [
        "Subject",
        "From",
        "To",
        "Inmate ID",
        "Message Cost($)",
        "Flag",
        "Sent",
        "Read",
        "Status",
        "Source",
        "Amount Debited On",
        "Is COD Message",
        "Mode Of Payment",
        "COD Status",
        "Approved/Rejected By",
        "User Type",
      ];

      // Map the account manager list to match the Excel format
      let list =
        loadMessageExcelList?.DataList?.map((obj) => ({
          Subject: obj.FullMessageSubject,
          From: obj.MessageFrom,
          To: obj.MessageTo,
          Inmate_ID: obj?.InmateResidentId,
          MessageCost: obj.MessageCost.toFixed(2),
          Flag: obj?.MessageBothFlagKeyWords,
          Sent: formatDateTimeAMPM(obj.MessageSentDate),
          //Read: formatDateTimeAMPM(obj?.MessageReceiveDate) || "-",
          Read: (obj?.MessageReceiveDate == "0001-01-01T00:00:00" || obj?.ModeOfPayment == "COD") ? "-" : formatDateTimeAMPM(obj.MessageReceiveDate),
          Status:
            (obj?.MessageStatus === "Read" && obj?.IsReceiverMsgDelete == 1) ? "Read & Message Deleted" :
              (obj?.MessageStatus === "Unread" && obj?.IsReceiverMsgDelete === 1) ? "Unread & Message Deleted" :
                obj?.MessageStatus === "Read" ? "Read" :
                  obj?.MessageStatus === "Unread" ? "Unread" :
                    obj?.MessageStatus === "Pending Quarantine Approval" ? "Quarantine Message" :
                      obj?.MessageStatus === "Reject Quarantine" ? "Quarantine Rejected" :
                        "C.O.D Pending",
          Source: obj.MessagePaymentSource,
          AmountDebitedOn: formatDateTimeAMPM(obj.DebitAmountDate) || "-",
          IsCODMessage: obj.IsCODMessage,
          ModeOfPayment: obj.ModeOfPayment,
          CODStatus: obj.CODStatus,
          ApprovedRejectedBy: obj.ApproveOrRejectedBy,
          UserType: obj.UserType,
        })) || [];

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(list, generateExcelColumns, title);

        // Clear excel data after the download
        dispatch(publicUserActions.clearMessageExcelList());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        console.error("Error generating Excel file:", error);
      }
    }
  }, [loadMessageExcelList]);

  const handleBack = () => {
    history.navigate("PublicUserList");
  };

  const directionOption = [
    { value: "0", label: "--ALL--" },
    { value: "1", label: "From Inmate" },
    { value: "2", label: "To Inmate" },
  ];
  const flagOption = [
    { value: "3", label: "--ALL--" },
    { value: "0", label: "No Flag" },
    { value: "1", label: "Flag" },
    { value: "2", label: "Quarantine" },
  ];

  const handleNavigateInfoFrom = () => {
    if (PuAccessPermission[0]?.SubMenuActiveStatus == 0) return;
    history.navigate("PublicUserList/Details", {
      state: { row: row, source: "publicUser" },
    });
    dispatch(publicUserActions?.setPublicUserTab("publicuser-info-tab"));
  };
  const handleNavigateInmateTo = (row) => {
    if (InmateAccessPermission[0]?.SubMenuActiveStatus == 0) return;
    dispatch(publicUserActions?.setPublicMessageValue(row));
    dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
    history.navigate("InmateList/Details", {
      state: {
        inmate: row,
        source: "publicUserMesage",
        row: row,
        showTransactionTab: false,
      },
    });
  };
  const handleNavigateInmateId = (row) => {
    if (InmateAccessPermission[0]?.SubMenuActiveStatus == 0) return;
    dispatch(publicUserActions?.setPublicMessageValue(row));
    dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
    history.navigate("InmateList/Details", {
      state: {
        inmate: row,
        source: "publicUserMesage",
        row: row,
        showTransactionTab: false,
      },
    });
  };

  const [linkshow, setLinkshow] = useState(false);

  const handleNavigateMessageSubject = (messageID) => {
    //if (linkshow === true) return;
    if (MessageAccessPermission[0]?.SubMenuActiveStatus === 0) {
      // showToastNotification(
      //   "View option has been disabled by the admin.",
      //   "error"
      // );
      setLinkshow(true);

      return;
    }
    //  dispatch(inmateAction.LoadPUMessageIDList({ ...messageList, rowCountPerPage: loadMessageList?.TotalRecordCount || 1000, PageNo: 1 })).then((result) => {
    let findIndex = loadMessageList?.DataList?.findIndex(x => x?.MessageID === messageID);
    history.navigate("MessageList/Conversation", {
      state: {
        messageID: messageID,
        source: "publicUserMessage",
        row: row,
        index: findIndex ? findIndex : 0
      },
    });
    //  })
  };

  const handleSearch = (e) => {
    e?.preventDefault();
    const updatedSearchOnSubmit = {
      ...messageList,
      PageNo: 1,
      rowCountPerPage: 10
    };
    dispatch(publicUserActions?.setpuInitialMessageSearch(updatedSearchOnSubmit));
    setIsLoading(true);
    dispatch(publicUserActions.LoadPUMessageSearch(updatedSearchOnSubmit)).then((x) => setIsLoading(false));
  };
  const updatedSearch = { ...messageList };
  const handleSelectChange = (selectedOption, name) => {
    // const updatedSearch = { ...messageList };

    const loadMessageList = () => {
      updatedSearch.PageNo = 1;
      updatedSearch.rowCountPerPage = 10;
      updatedSearch.sortField = "MessageID desc";
      dispatch(publicUserActions.LoadPUMessageSearch(updatedSearch));
    };

    const handleFirstName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.inmateFirstNameId = selectedOption?.value || 0;

      if (row?.PublicUserID || rows?.PublicUserID) {
        dispatch(
          publicUserActions.GetInmateLastName({
            facilityID: commonFacilityCode,
            firstName: "",
            PublicUserID: row?.PublicUserID || rows?.PublicUserID,
          })
        );
      }
      loadMessageList();
    };

    const handleLastName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.inmateLastNameId = selectedOption?.value || 0;

      updatedSearch.inmateFirstName = "";
      updatedSearch.inmateFirstNameId = 0;
      if (row?.PublicUserID || rows?.PublicUserID) {
        dispatch(
          publicUserActions.GetInmateFirstName({
            facilityID: commonFacilityCode,
            lastName: updatedSearch?.inmateLastName,
            PublicUserID: row?.PublicUserID || rows?.PublicUserID,
          })
        );
      }
      loadMessageList();
    };

    switch (name) {
      case "inmateLastName":
        handleLastName();
        break;

      case "inmateFirstName":
        handleFirstName();
        break;

      default:
        if (name === "messageFlag") {
          updatedSearch[name] = selectedOption?.value || "3";
          loadMessageList();
        } else {
          updatedSearch[name] = selectedOption?.value || "0";
          loadMessageList();
        }
        break;
    }
    dispatch(publicUserActions?.setpuInitialMessageSearch(updatedSearch));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    const numericValue = value.replace(/[^0-9]/g, "");

    updatedSearch[name] = numericValue;
    dispatch(publicUserActions?.setpuInitialMessageSearch(updatedSearch));
  };

  const handleDateChange = (name, value) => {
    const date = fDate(value);
    updatedSearch[name] = date;
    dispatch(publicUserActions?.setpuInitialMessageSearch(updatedSearch));
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "messageSendStartDate") {
      if (
        updatedSearch.messageSendEndDate &&
        new Date(value) > new Date(updatedSearch.messageSendEndDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "messageSendEndDate") {
      if (
        updatedSearch.messageSendStartDate &&
        new Date(value) < new Date(updatedSearch.messageSendStartDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...updatedSearch,
      messageSendStartDate:
        fieldName === "messageSendStartDate"
          ? isFromValid && isValidDate
            ? value
            : getPastDate(6)
          : updatedSearch.messageSendStartDate, // preserve existing value
      messageSendEndDate:
        fieldName === "messageSendEndDate"
          ? isToValid && isValidDate
            ? value
            : getCurrentDate()
          : updatedSearch.messageSendEndDate, // preserve existing value
    };
    dispatch(publicUserActions?.setpuInitialMessageSearch(updatedParam));
  };

  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && updatedSearch[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(name, currentDate);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const reset = {
    facilityID: commonFacilityCode,
    inmateID: 0,
    inmateResidentID: "",
    managementUserID: 1,
    userID: row?.PublicUserID,
    userFirstName: row?.FirstName,
    userLastName: row?.LastName,
    inmateFirstName: "",
    inmateLastName: "",
    inmateFirstNameId: 0,
    inmateLastNameId: 0,
    messageDirection: "0",
    messageSendStartDate: getPastDate(6),
    messageSendEndDate: getCurrentDate(),
    messageFlag: "3",
    PageNo: 1,
    rowCountPerPage: 10,
    sortField: "MessageID DESC",
  };
  const handleReset = () => {
    dispatch(publicUserActions?.setpuInitialMessageSearch({
      ...messageList,
      inmateFirstName: "",
      inmateLastName: "",
      inmateFirstNameId: 0,
      inmateLastNameId: 0,
      messageDirection: "0",
      messageSendStartDate: getPastDate(6),
      messageSendEndDate: getCurrentDate(),
      messageFlag: "3",
      inmateResidentID: "",
      rowCountPerPage: 10,
      PageNo: 1,
      sortField: "MessageID DESC",
    }));
    dispatch(publicUserActions.LoadPUMessageSearch(reset));
    if (row?.PublicUserID || rows?.PublicUserID) {
      dispatch(
        publicUserActions.GetInmateFirstName({
          facilityID: commonFacilityCode,
          lastName: "",
          PublicUserID: row?.PublicUserID || rows?.PublicUserID,
        })
      );
    }
    if (row?.PublicUserID || rows?.PublicUserID) {
      dispatch(
        publicUserActions.GetInmateLastName({
          facilityID: commonFacilityCode,
          firstName: "",
          PublicUserID: row?.PublicUserID || rows?.PublicUserID,
        })
      );
    }
  };
  //grid page Onchange
  const handlePageChange = (value) => {
    if (sorting) {
      sorting = false;
      return;
    }
    dispatch(publicUserActions?.setpuInitialMessageSearch({
      ...messageList,
      PageNo: value,
    }));
    dispatch(publicUserActions.LoadPUMessageSearch({ ...messageList, PageNo: value }));
  };
  const handleRowPerPage = (value) => {
    dispatch(publicUserActions?.setpuInitialMessageSearch({
      ...messageList,
      rowCountPerPage: value,
      PageNo: 1,
    }));
    dispatch(publicUserActions.LoadPUMessageSearch({ ...messageList, PageNo: 1, rowCountPerPage: value }));
  };
  let sorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...messageList };
    const newSortOrder = search.sortField?.includes(column.key)
      ? search.sortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortField = `${column.key} ${newSortOrder}`;
    // dispatch(publicUserActions?.setpublicUserListSearch(search));
    dispatch(publicUserActions?.setpuInitialMessageSearch(search));
    dispatch(
      publicUserActions.LoadPUMessageSearch({
        ...messageList,
        sortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const handleClickExcel = () => {
    const updateTotalRows = {
      ...messageList,
      RowCountPerPage: loadMessageList?.TotalRecordCount,
      exportExcel: true,
      PageNo: 1,
    };

    dispatch(publicUserActions.LoadPUMessageSearch(updateTotalRows));
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form>
        <div className="row">
          <div className="p-2 m-1 d-flex flex-wrap align-items-center">
            {/* Frequency */}
            <div className="col-md-4 col-sm-12 d-flex flex-wrap align-items-center me-1">
              <label className="fs-5" style={{ minWidth: "150px" }}>
                Public User Last Name :
              </label>

              <strong className="fs-5 text-end mx-2">
                {row?.LastName ||
                  rows?.LastName ||
                  infoInformationList?.LastName}
              </strong>
            </div>

            {/* Limit */}
            <div className="col-md-4 col-sm-12 d-flex flex-wrap align-items-center">
              <label className="fs-5" style={{ minWidth: "150px" }}>
                Public User First Name :
              </label>
              <strong className="fs-5 text-end mx-2">
                {row?.FirstName ||
                  rows?.FirstName ||
                  infoInformationList?.FirstName}
              </strong>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <NumberInput
                name="inmateResidentID"
                label="Inmate ID"
                value={messageList?.inmateResidentID}
                handleChange={handleChange}
                maxLength={18}
                type="text"
                placeholder="Enter Inmate ID"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <SelectInput
                options={inmateLastName}
                value={messageList?.inmateLastNameId}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "inmateLastName")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isClearable={messageList?.inmateLastNameId !== 0}
                isLoading={false}
                placeholder="Select State"
                label="Inmate Last Name"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              {/* */}
              <SelectInput
                options={inmateFirstName}
                value={messageList?.inmateFirstNameId}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "inmateFirstName")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={messageList?.inmateFirstNameId !== 0}
                placeholder="Select State"
                label="Inmate First Name"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              {/* Connection */}
              <SelectInput
                options={directionOption}
                value={messageList?.messageDirection} // This is the selected value (e.g., 0, 1)
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "messageDirection")
                }
                placeholder="Select messageDirection"
                label="Direction"
                isClearable={messageList?.messageDirection !== "0"}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <DateInput
                maxDate={
                  messageList.messageSendEndDate
                    ? messageList.messageSendEndDate
                    : new Date()
                }
                value={messageList?.messageSendStartDate}
                handleChange={(date) =>
                  handleDateChange("messageSendStartDate", date)
                }
                name="messageSendStartDate"
                label={"From Date"}
                // isClearable={
                //   messageList?.messageSendStartDate !== null &&
                //   messageList?.messageSendStartDate !== ""
                // }
                isClearable={false}
                // preventClear
                required={false}
                disabled={false}
                yearDropDown={true}
                monthDropDown={false}
                minDate={new Date(2017, 0, 1)}
                handleBlur={(e) => handleDateBlur(e, "messageSendStartDate")}
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "to")
                }
              ></DateInput>
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <DateInput
                name="toDate"
                label="To Date"
                value={messageList?.messageSendEndDate}
                minDate={
                  messageList?.messageSendStartDate
                    ? messageList?.messageSendStartDate
                    : new Date(2017, 0, 1)
                }
                handleChange={(date) =>
                  handleDateChange("messageSendEndDate", date)
                }
                // isClearable={
                //   messageList?.messageSendEndDate !== null &&
                //   messageList?.messageSendEndDate !== ""
                // }
                isClearable={false}
                // preventClear
                maxDate={new Date()}
                required={false}
                disabled={false}
                yearDropDown={false}
                monthDropDown={false}
                handleBlur={(e) => handleDateBlur(e, "messageSendEndDate")}
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "to")
                }
              ></DateInput>
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              {/* Status */}
              <SelectInput
                options={flagOption}
                value={messageList?.messageFlag}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "messageFlag")
                }
                isClearable={messageList?.messageFlag !== "3"}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                placeholder="Select flag"
                label={"Flag"}
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            // variant="danger"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            onClick={handleSearch}
            disabled={false}
            icon={"search"}
          ></Button>
          <Button
            variant="danger"
            className="me-2"
            onClick={handleReset}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };
  if (loading || isloading) return <CustomLoader />;

  return (
    <div>
      <div className=" p-2 ">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap">
          <h4 className="inner-subheader-bg text-color">
            <i class="fa fa-commenting me-2"></i>Messages
          </h4>
          <Button
            label="Back"
            type="button"
            //className="btn btn-danger"
            onClick={handleBack}
            icon={"fa-solid fa-angle-left"}
            variant="danger"
            status={"primary"}
            disabled={false}
          />
        </div>
      </div>
      <div className="card shadow-sm b-r-all p-4 border border-dark-grey  w-100">
        {/* Mobile only (Below md breakpoint) */}
        <div className=" d-block d-md-none">
          <div
            className=" d-flex align-items-center justify-content-between"
            style={{ background: "transparent", cursor: "pointer" }}
            onClick={toggleInformation}
          >
            <h2 className="form_title_uppercase text-color">SEARCH</h2>
            <i
              id="itagInformation"
              className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""}`}
              style={{ fontSize: "20px" }}
            ></i>
          </div>
        </div>
        {/* Mobile only (Below md breakpoint) */}
        <div className="d-block d-md-none mt-2">
          {showSearchFields && renderSearch()}
        </div>

        {/* Web only (Desktop and above) */}
        <div className="mb-3 d-none d-md-block">
          <h2 className="form_title_uppercase text-color"> SEARCH</h2>
        </div>
        {/* Web only (Desktop and above) */}
        <div className="d-none d-md-block">{renderSearch()}</div>
        {/* <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap">
          <h2 className="form_title_uppercase text-color">search</h2>
        </div> */}
        {/* <form>
          <div className="row">
            <div className="p-3 m-0 d-flex flex-wrap align-items-center">
              <div className="col-md-4 d-flex flex-wrap align-items-center me-4">
                <label className="fs-5" style={{ minWidth: "150px" }}>
                  Public User Last Name :
                </label>

                <strong className="fs-5 text-end mx-2">
                  {row?.LastName ||
                    rows?.LastName ||
                    infoInformationList?.LastName}
                </strong>
              </div>

              <div className="col-md-4 d-flex flex-wrap align-items-center">
                <label className="fs-5" style={{ minWidth: "150px" }}>
                  Public User First Name :
                </label>
                <strong className="fs-5 text-end mx-2">
                  {row?.FirstName ||
                    rows?.FirstName ||
                    infoInformationList?.FirstName}
                </strong>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <div className="form-floating mb-3">
                <NumberInput
                  name="inmateResidentID"
                  label="Inmate ID"
                  value={messageList?.inmateResidentID}
                  handleChange={handleChange}
                  maxLength={18}
                  type="text"
                  placeholder="Enter Inmate ID"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <div className="form-floating mb-3">
                <SelectInput
                  options={inmateLastName}
                  value={messageList?.inmateLastNameId}
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "inmateLastName")
                  }
                  isMulti={false}
                  closeMenuOnSelect={true}
                  isDisabled={false}
                  isClearable={messageList?.inmateLastNameId !== 0}
                  isLoading={false}
                  placeholder="Select State"
                  label="Inmate Last Name"
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-floating mb-3">
                <SelectInput
                  options={inmateFirstName}
                  value={messageList?.inmateFirstNameId}
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "inmateFirstName")
                  }
                  isMulti={false}
                  closeMenuOnSelect={true}
                  isDisabled={false}
                  isLoading={false}
                  isClearable={messageList?.inmateFirstNameId !== 0}
                  placeholder="Select State"
                  label="Inmate First Name"
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-floating mb-3">
                <SelectInput
                  options={directionOption}
                  value={messageList?.messageDirection} // This is the selected value (e.g., 0, 1)
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "messageDirection")
                  }
                  placeholder="Select messageDirection"
                  label="Direction"
                  isClearable={messageList?.messageDirection !== "0"}
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-floating mb-3">
                <DateInput
                  maxDate={
                    messageList.messageSendEndDate
                      ? messageList.messageSendEndDate
                      : new Date()
                  }
                  value={messageList?.messageSendStartDate}
                  handleChange={(date) =>
                    handleDateChange("messageSendStartDate", date)
                  }
                  name="messageSendStartDate"
                  label={"From Date"}
                  isClearable={false}
                  // preventClear
                  required={false}
                  disabled={false}
                  yearDropDown={true}
                  monthDropDown={false}
                  minDate={new Date(2017, 0, 1)}
                  handleBlur={(e) => handleDateBlur(e, "messageSendStartDate")}
                  handleKeyDown={(e) =>
                    handleDateEnterKey(e, "messageSendStartDate")
                  }
                ></DateInput>
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-floating mb-3">
                <DateInput
                  name="toDate"
                  label="To Date"
                  value={messageList?.messageSendEndDate}
                  minDate={
                    messageList?.messageSendStartDate
                      ? messageList?.messageSendStartDate
                      : new Date(2017, 0, 1)
                  }
                  handleChange={(date) =>
                    handleDateChange("messageSendEndDate", date)
                  }
                  isClearable={false}
                  // preventClear
                  maxDate={new Date()}
                  required={false}
                  disabled={false}
                  yearDropDown={false}
                  monthDropDown={false}
                  handleBlur={(e) => handleDateBlur(e, "messageSendEndDate")}
                  handleKeyDown={(e) =>
                    handleDateEnterKey(e, "messageSendEndDate")
                  }
                ></DateInput>
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-floating mb-3">
                <SelectInput
                  options={flagOption}
                  value={messageList?.messageFlag}
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "messageFlag")
                  }
                  isClearable={messageList?.messageFlag !== "3"}
                  isMulti={false}
                  closeMenuOnSelect={true}
                  isDisabled={false}
                  isLoading={false}
                  placeholder="Select flag"
                  label={"Flag"}
                />
              </div>
            </div>
          </div>

          <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
            <Button
              className="me-2"
              label={"SEARCH"}
              type={"submit"}
              status={"primary"}
              onClick={handleSearch}
              disabled={false}
              icon={"search"}
            ></Button>
            <Button
              variant="danger"
              className="me-2"
              onClick={handleReset}
              label={"RESET"}
              type={"button"}
              status={"secondary"}
              disabled={false}
              icon={"fa-solid fa-rotate-right"}
            />
          </div>
        </form> */}
      </div>

      <div className="mt-3">
        {loadMessageList?.DataList?.length > 0 && (
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 resp-space">
            <div className="d-flex flex-wrap gap-4">
              <div className="d-flex flex-wrap align-items-center gap-1">
                <div className="user-batch button-success"></div>
                <div className="text fs-5">Public Users</div>
              </div>

              <div className="d-flex flex-wrap align-items-center gap-1">
                <div className="user-batch button-primary"></div>
                <div className="text fs-5">Inmates</div>
              </div>

              <div className="d-flex flex-wrap align-items-center gap-1">
                <i
                  className="fa fa-flag flagged-message"
                  aria-hidden="true"
                ></i>
                <div className="text fs-5">Flagged Message</div>
              </div>

              <div className="d-flex flex-wrap align-items-center gap-1">
                <i
                  className="fa fa-flag non-flagged-message"
                  aria-hidden="true"
                ></i>
                <div className="text fs-5">Non Flagged Message</div>
              </div>
            </div>
            <div className="d-flex flex-wrap gap-3 align-items-center">
              <ExcelExport
                variant="soft-gray"
                handleExcelExport={handleClickExcel}
              />
            </div>
          </div>
        )}

        <Table
          columns={columns}
          data={loadMessageList?.DataList}
          pagination
          onChangeRowsPerPage={handleRowPerPage}
          onChangePage={handlePageChange}
          totalRowCount={loadMessageList?.TotalRecordCount}
          currentPage={messageList?.PageNo}
          paginationPerPage={messageList?.rowCountPerPage}
          onSort={handleSort}
          serverSideSort
          sortColumn={messageList?.sortField?.split(" ")[0]}
          sortDirection={messageList?.sortField?.split(" ")[1]}
        />
      </div>
    </div>
  );
}

export default React.memo(PublicUserMessage);
